import Vue from 'vue'
import vueCustomElement from 'vue-custom-element'
import VForm from './VForm/VForm.vue';
import 'document-register-element/build/document-register-element'; // IE polyfill
Vue.use(vueCustomElement)

Vue.customElement('v-form', VForm)
